import {
  renderLocationChoice,
  renderLocationInOrNear,
} from '../../../common/components/SearchHeader/types/LocationChoice';
import {
  getDayTerm,
  getInterestTerm,
  getSpecialtyPractitionerTerm,
  getSpecialtyTerm,
} from '../renderers';
import { SeoScenario } from '../types';
import { bulkBillingGpScenario, bookOnlineBulkBillingGpScenario } from './bulkBillingGp';
import { genericDirectory } from './genericDirectory';
import { mappingTo } from './mappingTo';
import { specialtyAppointment } from './specialtyAppointment';
import {
  telehealthAppointmentScenario,
  telehealthScenario,
  telehealthSpecialtyAppointmentsScenario,
  telehealthSpecialtyScenario,
} from './telehealth';

export const SeoScenarios = mappingTo<SeoScenario>()({
  afterHoursAppointment: it => {
    const specialist = getSpecialtyPractitionerTerm(it);
    const specialty = getSpecialtyTerm(it);
    const location = renderLocationChoice(it.location);
    const inOrNear = renderLocationInOrNear(it.location);

    return {
      pageTitle: `Book After Hours ${specialty} Appointments ${inOrNear} ${location}`,
      metaDescription: `Book an After Hours ${specialist} Appointment ${inOrNear} ${location} Online. 1000s of Appointments with Trusted Practitioners Available Every Day. Find an After Hours ${specialist} near you in ${location} with Healthengine and book online instantly!`,
      visualHeader: `After Hours ${specialty} Appointments ${inOrNear} ${location}`,
      textContent: `Book an after hours ${specialist}'s appointment this week in ${location}. Simply browse all after hours ${specialty} appointments available in and around ${location}, choose a time that suits you and book instantly online!

      Whether it's a baby, child, adult or the elderly Healthengine's network of trusted after hours physicians in ${location} will provide medical care and treatment for all patients - late at night, on the weekend or public holidays.
      
      Healthengine lets you be in complete control of your health at any hour day or night, connecting you with the right after hours ${specialist} when you need it the most. Find and book an after hours ${specialty} online, anywhere in ${location}, anytime. Start booking today!`,
    };
  },

  appointmentInterest: it => {
    const dayTerm = getDayTerm(it);
    const interestTerm = getInterestTerm(it);
    const location = renderLocationChoice(it.location);
    const inOrNear = renderLocationInOrNear(it.location);
    return {
      pageTitle: `Book practices with appointments for ${interestTerm} ${dayTerm} ${inOrNear} ${location}`,
      metaDescription: `Book appointments for ${interestTerm} ${inOrNear} ${location} instantly. 1000s of appointments with trusted practitioners available every day. Book a practice offering appointments for ${interestTerm} near you with Healthengine and find trusted practitioners in ${location}`,
      visualHeader: `Practices with appointments for ${interestTerm} ${dayTerm}${inOrNear} ${location}`,
      textContent: `Book appointments for ${interestTerm} ${inOrNear} ${location}. Simply browse all practices offering appointments for ${interestTerm} in and around ${location}, choose a time that suits you and book instantly online!Healthengine lets you be in complete control of your health and wellness, connecting you with the right practitioners when you need them the most. Find and book an appointment for ${interestTerm} online, anywhere in ${location}, anytime. Get started today!`,
    };
  },

  directoryInterest: it => {
    const interestTerm = getInterestTerm(it);
    const location = renderLocationChoice(it.location);
    const inOrNear = renderLocationInOrNear(it.location);

    return {
      pageTitle: `Find practices with services for ${interestTerm} ${inOrNear} ${location}`,
      metaDescription: `Find practices offering ${interestTerm} services within ${location}. Book an appointment online or view opening hours, contact details, services for ${interestTerm} and more in one easy location on Healthengine`,
      visualHeader: `Practices with services for ${interestTerm} ${inOrNear} ${location}`,
      textContent: `Find practices offering services for ${interestTerm} ${inOrNear} ${location}. We provide comprehensive information on practitioners and clinics with special interest in ${interestTerm} in and around ${location}, including real positive customer feedback, accreditations, contact details, staff profiles, opening hours, pricing and payment info and much more.Healthengine connects you with the best healthcare providers when you need them the most.`,
    };
  },

  specialtyAppointment: specialtyAppointment,

  bulkBillingGp: bulkBillingGpScenario,

  bookOnlineBulkBillingGp: bookOnlineBulkBillingGpScenario,

  genericDirectory: genericDirectory,

  telehealth: telehealthScenario,

  telehealthAppointment: telehealthAppointmentScenario,

  telehealthSpecialty: telehealthSpecialtyScenario,

  telehealthSpecialtyAppointments: telehealthSpecialtyAppointmentsScenario,
});
